import { CommentItemType } from "../../../../../../createEscalation.models";

export const TIMELINE_LINE_BACKGROUND:Record<CommentItemType, string> = {
    [CommentItemType.DRAFT_COMMENT]: "#DBEAFE",
    [CommentItemType.ESCALATION_RAISED]: "#DBEAFE",
    [CommentItemType.EMAIL_SENT]: "#DCFCE7",
    [CommentItemType.COMMENT_ADDED]: "#DBEAFE",
    [CommentItemType.STATUS_CHANGED]: "#DBEAFE",
};
